import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactHogyVagyMostContent from '@/components/contact/ContactHogyVagyMostContent'

export default function ContactHogyVagyMost() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Hogy vagy most | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés a Hogy Vagy Most? művészetterápiás workshopra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/hogy-vagy-most" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Hogy vagy most) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés a &quot;Hogy vagy Most?&quot; művészetterápiás workshopra"
          hidden="hogy-vagy-most"
          content={<ContactHogyVagyMostContent />}
        >
          <img
            src={`${config.basePath}/images/hogy-vagy-most.webp`}
            alt="Hogy vagy most?"
            width={"100%"}
          />
        </Contact>
      </section>
      
      <div className="mx-auto w-3/4 mb-8">
        <p>
          <strong>Adatkezelési tájékoztatás:</strong> Az űrlap kitöltésével hozzájárulsz adataid kommunikáció és kapcsolattartás céljára történő kezeléséhez. Az Európai Parlament és Tanács (EU) 2016/679. rendelete (továbbiakban: GDPR) a személyes adatok kezelésére vonatkozó rendelete az irányadó az adatok kezelésében.
        </p>
      </div>
    </>
  )
}
